/**
 * Section 01's working (Results-v5 "how"): each step a row, the date in mono on the right,
 * where it comes from under the label. Nira computes these from the statutory table; the
 * model only explains them. The verdict row closes it; caveats follow in small print.
 */
export function Limitation({ verdict, summary, rows, caveats = [] }: {
  verdict: "late" | "in_time" | "unknown"
  summary: string
  rows: { label: string; value: string; basis?: string }[]
  caveats?: string[]
}) {
  return (
    <div className="alimit" data-verdict={verdict} aria-label="How the time limit is worked out" role="group">
      <dl>
        {rows.map((r, i) => {
          const last = r.label === "Late by" || r.label === "In time by"
          return (
            <div className={`r${last ? " end" : ""}`} key={i}>
              <dt>
                {r.label}
                {r.basis ? <span className="b">{r.basis}</span> : null}
              </dt>
              <dd className="m">{r.value}</dd>
            </div>
          )
        })}
      </dl>
      <p className="vh">{summary}</p>
      {caveats.length ? (
        <ul className="alimit-cav">
          {caveats.map((c, i) => <li key={i}>{c}</li>)}
        </ul>
      ) : null}
    </div>
  )
}
